import { ReactElement } from 'react';

import { MessageType } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';
import { PrescriptionStatus } from '../../common/PrescriptionStatus';

export const PatientInPersonExaminationRequiredStatus = (): ReactElement => {
   return (
      <PrescriptionStatus
         type={MessageType.WARNING}
         label={draftPrescriptionsTranslationKeys.patientInPersonExaminationRequired}
         testId={'patientInPersonExaminationRequired'}
      />
   );
};
